import Recaptcha3 from '@/utils/Recaptcha3';

export default {
  state: () => ({
    data: {},
  }),
  mutations: {
    'repair/setState'(state, payload) {
      state.data = { ...payload };
    },
    'repair/setResponse'(state, payload) {
      state.data = { ...state.data, response: payload };
    },
    'repair/removeError'(state, payload) {
      state.data = {
        ...state.data,
        response: null,
      };
    },
  },
  actions: {
    async 'repair/getRepairStatusByNumber'({ state: { data }, commit }, payload) {
      try {
        commit('global/loaderStart');
        const { path, action } = data.routes.getRepairStatusByNumber;
        const requestData = payload;
        let repairNumber = '';

        if (payload instanceof FormData) {
          requestData.set('action', action);
          repairNumber = requestData.get('repairNumber');
        } else {
          payload.action = action;
          repairNumber = payload.payload;
        }

        const { status, data: responseData } = await axios.post(path, requestData);

        if (status !== 200) throw `Bad request response status: ${status}`;
        commit('repair/setResponse', { ...responseData, repairNumber });
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'repair/updateRepairStatusByNumber'({ state: { data }, commit }, payload) {
      try {
        commit('global/loaderStart');
        const token = await Recaptcha3.getSubmitToken();

        const { path, action } = data.routes.getRepairStatusByNumber;
        const requestData = {
          ...payload,
          action,
          'g-recaptcha-response': token,
        };
        // let repairNumber = '';

        // if (payload instanceof FormData) {
        //   requestData.set('action', action);
        //   repairNumber = requestData.get('repairNumber');
        // } else {
        //   payload.action = action;
        //   repairNumber = payload.payload;
        // }

        const { status, data: responseData } = await axios.post(path, requestData);

        if (status !== 200) throw `Bad request response status: ${status}`;

        // console.log(responseData);
        const arStatus = responseData?.bitrixData?.arStatus;
        // console.log(arStatus);
        if (arStatus) {
          commit('repair/setState', {
            ...data,
            items: [
              ...data.items.map((el) => {
                if (el.UF_XML_ID === payload.repairNumber) {
                  return {
                    ...el,
                    arStatus: {
                      ...arStatus,
                    },
                  };
                }
                return el;
              }),
            ],
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'repair/checkAnotherNumber'({ commit }) {
      try {
        commit('global/loaderStart');
        const { status, data: responseData } = await axios.get(location.href, {
          params: {
            api: 'Y',
          },
        });

        commit('repair/setState', responseData);
        commit('global/loaderStop');
        if (status !== 200) throw 'something went wrong!!';
      } catch (err) {
        console.error(err);
      }
    },
    async 'repair/getBoxItemsByQuery'({ state: { data }, commit }, payload) {
      try {
        commit('global/loaderStart');
        const { path, action } = data.routes.getBoxItemsByQuery;

        const requestData = {
          query: payload,
          action,
        };

        // let repairNumber = '';

        // if (payload instanceof FormData) {
        //   requestData.set('action', action);
        //   repairNumber = requestData.get('repairNumber');
        // } else {
        //   payload.action = action;
        //   repairNumber = payload.payload;
        // }

        const { status, data: responseData } = await axios.post(path, requestData);

        if (status !== 200) throw `Bad request response status: ${status}`;
        // console.log(data);
        // console.log({ ...data, boxActiveList: responseData.result });
        commit('repair/setState', { ...data, boxActiveList: responseData.result });
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'repair/createRepairRequest'({ state: { data }, commit }, payload) {
      try {
        commit('global/loaderStart');
        const { path, action } = data.routes.createRepairRequest;

        const requestData = payload;

        requestData.set('action', action);

        const telnumber = requestData.get('telnumber');

        if (telnumber) {
          requestData.set('telnumber', telnumber.replace('+', '').replace(/ /g, ''));
        }

        // const requestData = {
        //   query: payload,
        //   action,
        // };

        // let repairNumber = '';

        // if (payload instanceof FormData) {
        //   requestData.set('action', action);
        //   repairNumber = requestData.get('repairNumber');
        // } else {
        //   payload.action = action;
        //   repairNumber = payload.payload;
        // }

        const { status, data: responseData } = await axios.post(path, requestData);

        if (status !== 200) throw `Bad request response status: ${status}`;

        return responseData;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
  },
};
